export const DISABLED_SUBTITLES = 'disable';

export const DISABLED_SUBTITLES_ID = -1;
